import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import Cadastro from "@/pages/Cadastro";

export const Route = createFileRoute("/cadastro")({
  head: () => seoHead({
    title: "Criar Conta Shopping do Bem | Compre e doe sem custo",
    description: "Crie sua conta gratuita no Shopping do Bem e transforme suas compras em doações para causas sociais, sem custo extra.",
    path: "/cadastro",
  }),
  component: Cadastro,
});
